/** Nivel de audiencia — sincronizado con enum gfi_session_level */
export const SESSION_LEVELS = [
  { value: 'new_associate', label: 'Nuevos Agentes' },
  { value: 'licensed', label: 'Licenciados' },
  { value: 'both', label: 'Todos los niveles' },
];

/** Etiquetas sugeridas (mock + uso habitual) */
export const SUGGESTED_TRAINING_TAGS = [
  'Ventas',
  'Mindset',
  'Educación Financiera',
  'Desarrollo Personal',
  'Onboarding',
];

export const COMPLIANCE_LABEL =
  'Confirmo que este contenido cumple con las políticas de GFI Latino';

/** Content lifecycle — synced with enum gfi_training_content_status */
export const TRAINING_CONTENT_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
};

/** Default stale-draft threshold (days). Overridden by gfi_app_settings.training_stale_draft_days */
export const DEFAULT_STALE_DRAFT_DAYS = 14;

/** Slugs for library row "Ver todo" routes (not Camino UUIDs). */
export const TRAINING_ROW_SLUGS = {
  CONTINUE: 'continue',
  ALL_SESSIONS: 'all-sessions',
};

export function getTrainingRowListPath(rowId) {
  return `/app/entrenamientos/fila/${rowId}`;
}
